export default __webpack_public_path__ + "static/media/3 ESE OJO NEGRO QUE ME VISITA CADA NOCHE.52dfb2e2.png";